
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/watch-online/[slug]",
      function () {
        return require("private-next-pages/watch-online/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/watch-online/[slug]"])
      });
    }
  